import { Component, Input, ViewEncapsulation } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { BllExpandComponent } from '../expand';
@Component({
  selector: 'bll-accordion-workflow',
  template: `<ng-content></ng-content>`,
  host: {
    class: 'bll-accordion-workflow',
  },
  styleUrls: ['./accordion-workflow.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BllAccordionWorkflowComponent extends BllExpandComponent {
  @Input()
  get iconCenter(): any {
    return this._iconCenter;
  }
  set iconCenter(value: any) {
    this._iconCenter = coerceBooleanProperty(value);
  }
  _iconCenter: boolean = false;

  @Input()
  get iconArrow(): any {
    return this._iconArrow;
  }
  set iconArrow(value: any) {
    this._iconArrow = coerceBooleanProperty(value);
  }
  _iconArrow = true;

  @Input() multi: boolean = false;

  @Input()
  get iconClass(): string {
    return this._iconClass;
  }
  set iconClass(value) {
    this._iconClass = value;
  }
  _iconClass: string;

  @Input() iconSize: number = 18;
}
